module.exports = __webpack_public_path__ + "static/media/abhishek-iit.9c8876a9.png";